import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";
import { Input } from "@/components/ui/input";
import { useEffect, useState } from "react";


export function RatingForm() {
    const { isFormDisabled, form } = useFieldFormContext();
    const field_max = form?.watch('field_max');
    const [max, setMax] = useState<string>(field_max?.toString() || "10");
    useEffect(() => {
        setMax("10");
    }, []);
    useEffect(() => {
        form?.setValue("field_max", max ? parseInt(max) : null);
    }, [form, max]);

    return (
        <div className="flex flex-col gap-2">
            <p className="text-sm font-medium">Maximum</p>
            <Input
                value={max}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMax(e.target.value)}
                disabled={isFormDisabled}
                type='number'
                min={1}
                autoComplete="off"
            />
        </div>
    )
}
